$(document).ready(function(){
    $('.js-mask-99-99').inputmask("99 / 99"); 
});